import React, { useState } from "react";
import { connect } from "react-redux";
import { useRequiredAuth } from "../../common/guard/requiredAuth";
import { AppBar, Box, IconButton, Tab, Tabs, Toolbar } from "@mui/material";
import { TabPanel, a11yProps } from "../../common/components/TabPanel";
import OversightDashboard from "./OversightDashboard";
import UniDashboard from "./UniDashboard";

const Dashboard = (props) => {
  const { user } = props;
  const { hasPermissions } = useRequiredAuth();
  const isForInstitution =
    (user.selectedEntitySector.id === "1700000000-090000000000000000-11"
      ? hasPermissions(["IS_HEAD_OF_INSTITUTION"])
      : hasPermissions(["IS_CBM", "IS_HR", "IS_DAF", "IS_TECHNICAL_HEAD"])) &&
    !hasPermissions(["IS_ADMIN"]);
  const isTechnicalHead =
    ((user.selectedEntitySector.id === "1700000000-090000000000000000-11" &&
      hasPermissions(["IS_HEAD_OF_INSTITUTION"])) ||
      (hasPermissions(["IS_TECHNICAL_HEAD"]) &&
        !hasPermissions(["IS_CBM", "IS_HR", "IS_DAF"]))) &&
    !hasPermissions(["IS_ADMIN"]);
  const isHeadOfUnit = hasPermissions(["IS_HEAD_OF_UNIT"]);
  const [value, setValue] = useState(0);
  const [showFilter, setShowFilter] = useState(false);
  const [showReport, setShowReport] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Box sx={{ display: "flex", width: "100%" }}>
        <div className="w-100">
          <AppBar
            position="static"
            elevation={0}
            className="app-bar w-100 mb-0 pb-0"
          >
            <Toolbar className="mb-0 pb-0">
              <Tabs
                variant="scrollable"
                scrollButtons="auto"
                allowScrollButtonsMobile
                className="mb-0 pb-0"
                value={value}
                onChange={handleChange}
              >
                {isForInstitution && (
                  <Tab label="Institution Dashboard" {...a11yProps(0)} />
                )}
                {isHeadOfUnit && (
                  <Tab
                    label="Unity Dashboard"
                    {...a11yProps(isForInstitution ? 1 : 0)}
                  />
                )}
              </Tabs>
              <Box sx={{ flexGrow: 1 }} />
              <div className="d-flex flex-row align-items-center rounded border px-1 ml-2">
                <IconButton
                  color="default"
                  aria-label="Refresh"
                  title="Refresh"
                  component="label"
                  size="small"
                  onClick={() => {
                    setRefresh(!refresh);
                  }}
                >
                  <span className="material-icons-outlined">refresh</span>
                </IconButton>
                <IconButton
                  color={!showFilter ? "primary" : "default"}
                  aria-label="filter leaves"
                  title="Filter leaves"
                  component="label"
                  size="small"
                  onClick={() => {
                    setShowFilter(!showFilter);
                    setShowReport(false);
                  }}
                >
                  <span className="material-icons-outlined">
                    {!showFilter ? "filter_list" : "filter_list_off"}
                  </span>
                </IconButton>
                <IconButton
                  color={!showReport ? "error" : "default"}
                  aria-label="generate leave report"
                  title="Generate leave report"
                  component="label"
                  size="small"
                  className="ml-1"
                  onClick={() => {
                    setShowReport(!showReport);
                    setShowFilter(false);
                  }}
                >
                  <span className="material-icons-outlined">
                    {!showReport ? "download" : "file_download_off"}
                  </span>
                </IconButton>
              </div>
            </Toolbar>
          </AppBar>

          <div>
            {isForInstitution && (
              <TabPanel value={value} index={0}>
                <React.Fragment>
                  <OversightDashboard
                    showFilter={showFilter}
                    setShowFilter={setShowFilter}
                    showReport={showReport}
                    setShowReport={setShowReport}
                    isTechnicalHead={isTechnicalHead}
                    refresh={refresh}
                  />
                </React.Fragment>
              </TabPanel>
            )}
            {isHeadOfUnit && (
              <TabPanel value={value} index={isForInstitution ? 1 : 0}>
                <React.Fragment>
                  <OversightDashboard
                    showFilter={showFilter}
                    setShowFilter={setShowFilter}
                    showReport={showReport}
                    setShowReport={setShowReport}
                    isTechnicalHead={isTechnicalHead}
                    refresh={refresh}
                    roleType="HOU"
                  />
                </React.Fragment>
              </TabPanel>
            )}
          </div>
        </div>
      </Box>
    </>
  );
};

const mapStateToProps = ({ user }) => {
  return { user };
};
export default connect(mapStateToProps, {})(Dashboard);
